import { useTranslation } from "react-i18next";
import { Building2, Scale, Users, Shield } from "lucide-react";

const placeholders = [
  { icon: Building2, labelKey: "trust.lawFirms" },
  { icon: Scale, labelKey: "trust.legalDepts" },
  { icon: Users, labelKey: "trust.compliance" },
  { icon: Shield, labelKey: "trust.enterprises" },
];

export default function TrustSection() {
  const { t } = useTranslation();

  return (
    <section
      className="py-20 md:py-24 border-y border-[var(--landing-border)]"
      style={{ backgroundColor: "var(--landing-surface)" }}
    >
      <div className="container mx-auto px-4">
        <p
          className="text-center text-sm font-semibold uppercase tracking-wider mb-12"
          style={{ color: "var(--landing-text-secondary)" }}
        >
          {t("trust.title")}
        </p>
        <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10">
          {placeholders.map(({ icon: Icon, labelKey }) => (
            <div
              key={labelKey}
              className="flex items-center gap-3 px-6 py-4 rounded-xl border border-[var(--landing-border)]"
              style={{
                backgroundColor: "var(--landing-surface)",
                boxShadow: "var(--landing-shadow)",
              }}
            >
              <div
                className="flex items-center justify-center w-11 h-11 rounded-xl"
                style={{ backgroundColor: "var(--landing-surface-alt)" }}
              >
                <Icon className="h-5 w-5" style={{ color: "var(--landing-primary)" }} />
              </div>
              <span
                className="text-sm font-medium"
                style={{ color: "var(--landing-text-secondary)" }}
              >
                {t(labelKey)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
